import React from 'react'

const IconSmall = () => {
  return (
    <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 4.05405C0 1.81506 1.81506 0 4.05405 0H22.973C25.212 0 27.027 1.81506 27.027 4.05405V22.973C27.027 25.212 25.212 27.027 22.973 27.027H4.05405C1.81506 27.027 0 25.212 0 22.973V4.05405Z" fill="white"/>
    <path d="M13.5135 17.027C13.5135 14.788 15.3286 12.973 17.5676 12.973H36.4865C38.7255 12.973 40.5405 14.788 40.5405 17.027V35.9459C40.5405 38.1849 38.7255 40 36.4865 40H17.5676C15.3286 40 13.5135 38.1849 13.5135 35.9459V17.027Z" fill="white"/>
    <path d="M6.75676 10.5405C6.75676 8.30155 8.57182 6.48649 10.8108 6.48649H29.7297C31.9687 6.48649 33.7838 8.30155 33.7838 10.5405V29.4595C33.7838 31.6985 31.9687 33.5135 29.7297 33.5135H10.8108C8.57182 33.5135 6.75676 31.6985 6.75676 29.4595V10.5405Z" fill="#79589F"/>
    <path d="M27.027 6.48649H31.0811C32.5737 6.48649 33.7838 7.69653 33.7838 9.18919V12.973H27.027V6.48649Z" fill="white"/>
    <path d="M6.75676 27.027H13.5135V33.5135H9.45946C7.9668 33.5135 6.75676 32.3035 6.75676 30.8108V27.027Z" fill="white"/>
    <path d="M13.5135 17.027C13.5135 14.788 15.3286 12.973 17.5676 12.973H27.027V22.973C27.027 25.212 25.212 27.027 22.973 27.027H13.5135V17.027Z" fill="white"/>
    </svg>
    
  )
}

export default IconSmall